import React, { useRef } from 'react'
import { FilterBar } from '@panwds/react-filters'
import { Input } from '@panwds/react-ui'
import { SearchIcon } from '@panwds/icons'

export const TableFilterBar = ({ ...props }: any) => {
    const inputRef = useRef<HTMLInputElement>(null)

    // Function to handle clearing all filters
    const handleClearAll = () => {

        // Clear the global filter input field if it exists
        if (inputRef.current) {
            inputRef.current.value = ''
        }

        // Clear any global filter on the table
        if (props.tableInstanceRef?.setGlobalFilter) {
            props.tableInstanceRef.setGlobalFilter('')
        }
    }

    return (
        <div className="tw-flex tw-items-center">
            <div>
                <Input
                    ref={inputRef}
                    aria-label="Table filter"
                    placeholder="Search..."
                    onChange={(e) => {
                        const searchValue = e.target.value;
                        if (props.tableInstanceRef?.setGlobalFilter) {
                            props.tableInstanceRef.setGlobalFilter(searchValue);
                        }
                    }}
                    suffix={
                        <div className="tw-flex tw-items-center tw-justify-center tw-pr-3 tw-h-full">
                            <SearchIcon size="md" className="tw-text-steel-gray-300 dark:tw-text-steel-gray-400" />
                        </div>
                    }
                />

            </div>
            <div>
                <FilterBar
                    name="FilterAndTable"
                    filters={
                        props?.tableComponentFilterBar?.filterConfig
                            ? props.tableComponentFilterBar?.filterConfig
                            : []
                    }
                    saveOnUnmount={false}
                    hideAddFilter={
                        props?.tableComponentFilterBar?.hideAddFilter || false
                    }
                    reinitialize
                    onResetClicked={handleClearAll} // Use custom clear function
                />
            </div>
        </div>
    )
}
